import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {Document} from '../../../shared/interface/document';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {HttpErrorResponse} from '@angular/common/http';
import {Registration} from '../../../shared/interface/registration';
import {RegistrationService} from '../../../shared/services/registration.service';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {DocumentAddDialogComponent} from '../../documents/document-add-dialog/document-add-dialog.component';
import {
  FILE_TYPE_ALLIANZ_CERT, FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
  FILE_TYPE_ALLIANZ_CERT_FRAUDS, FILE_TYPE_ALLIANZ_CERT_MY_CAR, FILE_TYPE_AUTHORIZATION,
  FILE_TYPE_CERT_100P,
  FILE_TYPE_CERT_40P,
  FILE_TYPE_DIPLOMA, FILE_TYPE_INITIAL_TRAINING, FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU
} from '../../../shared/services/dict.service';
import {
  IC_ALLIANZ, IC_INTER_POLSKA,
  IC_INTER_POLSKA_LIFE,
  IC_PZU,
  IC_PZU_LIFE
} from '../../../shared/services/insurance-company.service';

@Component({
  selector: 'app-registration-details',
  templateUrl: './registration-details.component.html',
  styleUrls: ['./registration-details.component.scss']
})
export class RegistrationDetailsComponent implements OnInit, OnDestroy {
  @Input() register?: string;
  registrationId: string;
  registrationObject?: Registration;
  registration: ReplaySubject<Registration> = new ReplaySubject<Registration>(1);
  documents: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);
  modify = false;
  modifyIdentifier = false;
  reloadProfileListSubject = new ReplaySubject(1);
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private registrationService: RegistrationService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.registrationId = params.id;
        this.loadRegistration();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 3) {
      this.loadDocuments();
    }
  }

  loadDocuments(): void {
    this.registrationService.getRegistrationDocuments(this.registrationId)
      .subscribe((documents: ListResponse<Document>) => {
        this.documents.next(documents.items);
      });
  }

  addDocument(): void {
    const types = [
      FILE_TYPE_CERT_40P,
      FILE_TYPE_CERT_100P,
      FILE_TYPE_DIPLOMA,
      FILE_TYPE_AUTHORIZATION,
    ];

    // if (this.registrationObject.insuranceCompany.key === IC_ALLIANZ) {
    //   types.push(FILE_TYPE_ALLIANZ_CERT, FILE_TYPE_ALLIANZ_CERT_FRAUDS, FILE_TYPE_ALLIANZ_CERT_MY_CAR, FILE_TYPE_ALLIANZ_CERT_DOCUMENTS);
    // }

    if ([IC_PZU, IC_PZU_LIFE].includes(this.registrationObject.insuranceCompany.key)) {
      types.push(FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU);
    }

    if ([IC_INTER_POLSKA_LIFE, IC_INTER_POLSKA].includes(this.registrationObject.insuranceCompany.key)) {
      types.push(FILE_TYPE_INITIAL_TRAINING);
    }

    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        registrationObject: this.registrationObject,
        ofwcaObject: this.registrationObject.ofwca,
        insuranceCompanyObject: this.registrationObject.insuranceCompany,
        types,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadDocuments();
      this.loadRegistration();
    });
  }

  loadRegistration(): void {
    this.registrationService.get(this.registrationId).subscribe((registration: Registration) => {
      this.registration.next(registration);
      this.registrationObject = registration;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych rejestracji', error.status.toString(), {
        duration: 2000
      });
    });

    this.reloadProfileListSubject.next();
  }

  onDocumentAdded(): void {
    this.loadDocuments();
    this.loadRegistration();
  }
}
